module.exports = __webpack_public_path__ + "static/media/services-plan-icon.af8717fb.svg";